import { useLanguage } from '@/shared/contexts/LanguageContext';
import PageMeta from '@/shared/components/PageMeta';
import { Button } from '@/shared/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <PageMeta title="404" description="Page not found." />
      <div className="text-center space-y-6">
        <p className="text-7xl font-thin text-muted-foreground/40">404</p>
        <h1 className="text-2xl font-light text-foreground">
          {language === 'zh' ? '页面不存在' : 'Page not found'}
        </h1>
        <p className="text-sm text-muted-foreground">
          {language === 'zh'
            ? '你访问的页面可能已被移动或删除。'
            : 'The page you are looking for may have been moved or removed.'}
        </p>
        <Button asChild variant="outline">
          <Link to="/" className="inline-flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" />
            {language === 'zh' ? '返回首页' : 'Back to home'}
          </Link>
        </Button>
      </div>
    </div>
  );
}
